import styled, { css } from "styled-components";

const NoContentWrapper = styled.div`
	display: flex;
	padding: 40px 30px;
	flex-direction: column;
	align-items: center;
	gap: 10px;
	flex: 1 0 0;
	border-radius: 20px;
	background: var(--profile-page-wrapper-bg);
	min-height: 50vh;

	${({ noBackground }) =>
		noBackground &&
		css`
			background: transparent;
		`}
`;

const NoContentTitle = styled.div`
	color: #fff;
	text-align: center;
	font-size: 24px;
	font-weight: 600;
	line-height: 32px;
	letter-spacing: 0.75px;
	padding: 0 10px;
`;

const NoContentDescription = styled.div`
	color: #fff;
	text-align: center;
	font-size: 12px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.3px;
	padding: 0 10px;
`;

export { NoContentDescription, NoContentTitle, NoContentWrapper };
